
import { Component, Prop, Vue } from 'vue-property-decorator'
import {RequestPaging} from "@/utils/util";
import lsPagination from '@/components/ls-pagination.vue'
import {apiShortVideoList, apiShortVideoAudit} from '@/api/shop'

import {ShortVideoStatus} from "@/utils/type";
@Component({
  components: {
    lsPagination
  }
})
export default class ShortVideoIndex extends Vue {
  queryObj:any = {
    name: '',
    shop_name: '',
  }
  activeName : any ='all'
  selectIds: any = []
  pager = new RequestPaging()
  auditDialog = false
  form:any = {
    ids: [],
    status: 1,
    audit_reason: ''
  }
  
  get disabledBtn() {
    return !this.selectIds.length
  }
  
  getList(page?: number ): void {
    page && (this.pager.page = page)
    this.pager.request({
      callback: apiShortVideoList,
      params: {
        status: this.activeName != 'all' ? ShortVideoStatus[this.activeName] : '',
        ...this.queryObj
      }
    }).then(res => {
    })
  }
  handleReset() {
    this.queryObj = {
      name: '',
      shop_name: '',
    }
    this.getList()
  }
  
  handleSelect(val: any[]) {
    console.log(val)
    this.selectIds = val.map(item => item.id)
  }
  
  checkSelect(row: any, index: number) {
    return row.status == 0
  }
  
  batchAudit() {
    this.auditDialog = true
    this.form = {
      ids: this.selectIds,
      status: 1,
      audit_reason: ''
    }
  }
  
  handleBatchAudit(id: number) {
    this.form = {
      ids: [id],
      status: 1,
      audit_reason: ''
    }
    this.auditDialog = true
  }
  doAudit() {
    if (this.form.status == 2 && this.form.audit_reason.trim() == '') {
      this.$message.error('请输入驳回原因')
      return
    }
    apiShortVideoAudit(this.form).then(res => {
      this.getList();
      this.auditDialog = false;
    })
  }
  
  created() {
    this.getList()
  }
}
